import { render, staticRenderFns } from "./compose.vue?vue&type=template&id=591c5f34&"
import script from "./compose.vue?vue&type=script&lang=js&"
export * from "./compose.vue?vue&type=script&lang=js&"
import style0 from "./compose.vue?vue&type=style&index=0&id=591c5f34&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports